import { useCookies } from 'react-cookie';
import { Link, useNavigate } from 'react-router-dom';
import {
  ADMIN_ROLES,
  CUSTOMER_CARE_ROLES,
  OFFICE_HEAD_ROLES,
} from '../constants/roles';
import { MerchantSelector } from '../components/MerchantSelector';

export default function Navbar() {
  const navigate = useNavigate();
  const [cookies] = useCookies(['role']);
  const role = cookies.role ?? '';

  return (
    <header>
      <nav className="w-full bg-primary-0">
        <div className="flex justify-between">
          <button
            className="px-6 py-2 sm:hidden xl:block"
            onClick={() => navigate('/')}
          >
            <img alt="Logo" src="./logo.png" className="h-[58px] w-[89px]" />
          </button>
          <div
            id="header-cta"
            className="flex items-center p-4 sm:col-span-6 lg:col-span-6 xl:gap-6"
          >
            {OFFICE_HEAD_ROLES.includes(role) ? (
              <>
                <Link
                  className="text-md font-normal hover:text-blue-600"
                  to="/client"
                >
                  Clients
                </Link>
                <Link
                  className="text-md font-normal hover:text-blue-600"
                  to="/lounges"
                >
                  Lounges
                </Link>
                <Link
                  className="text-md font-normal hover:text-blue-600"
                  to="/devices"
                >
                  Devices
                </Link>
                <Link
                  className="text-md font-normal hover:text-blue-600"
                  to="/card-category"
                >
                  Card-Category
                </Link>
                <Link
                  className="text-md font-normal hover:text-blue-600"
                  to="/bin-search"
                >
                  BINs
                </Link>
                <Link
                  className="text-md font-normal hover:text-blue-600"
                  to="/eligibility-attempts"
                >
                  Eligibility-Attempts
                </Link>
              </>
            ) : null}
            {ADMIN_ROLES.includes(role) ? (
              <>
                <Link
                  className="text-md font-normal hover:text-blue-600"
                  to="/reports"
                >
                  Reports
                </Link>
                <Link
                  className="text-md font-normal hover:text-blue-600"
                  to="/users"
                >
                  Users
                </Link>
              </>
            ) : null}
            {CUSTOMER_CARE_ROLES.includes(role) ? (
              <>
                <Link
                  className="text-md font-normal hover:text-blue-600"
                  to="/"
                >
                  Transactions
                </Link>

                <Link
                  className="text-md font-normal hover:text-blue-600"
                  to="/eligibility-attempts"
                >
                  Eligibility Attempts
                </Link>
              </>
            ) : null}
            <div className="ml-auto">
              <MerchantSelector />
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
